export const SellSideLockFieldName = {
  INVESTOR_ID: 'investorId',
  INVESTOR_LOAN_NUMBER: 'investorLoanNumber',
  COMMITMENT_NUMBER: 'commitmentNumber',
  INVESTOR_LOCK_DATE: 'investorLockDate',
  INVESTOR_LOCK_EXPIRATION: 'investorLockExpiration',
};

export const SELL_SIDE_LOCK_NUMBER_MAX_LENGTH = 255;

export const MANUAL_SELL_PRICE_HINT = 'Entered manually. Clear it to use the Optimal Blue price.';
